module.exports = __webpack_public_path__ + "assets/img/33_82_big.df79cdc9.jpg";